import React from "react";
import { createPortal } from "react-dom";

interface ModalBackdropProps {
  onClose?: () => void;
  className?: string;
  children: React.ReactNode;
}

export const ModalBackdrop: React.FC<ModalBackdropProps> = ({
  onClose,
  className,
  children,
}) => {
  const root = document.getElementById("root");

  if (!root) throw new Error("Root node not found. Cannot render modal.");

  const animationClasses = "transition-all duration-300 ease-in-out";

  return createPortal(
    <div
      className={`fixed flex justify-center items-center top-0 left-0 bottom-0 right-0 z-50 bg-black/40 ${animationClasses} ${className}`}
      onClick={() => {
        onClose && onClose();
      }}
    >
      {children}
    </div>,
    root
  );
};
